import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format, set } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { IBranchWiseIncentive } from "./BranchIncentive";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";

interface IProps {
    setModal: (modal: { open: boolean, singleData: IBranchWiseIncentive[] }) => void,
    modal: { open: boolean, singleData: IBranchWiseIncentive[] },
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
}

export const GenerateInvoice = (props: IProps) => {
    const [tableData, setTableData] = useState<Array<IBranchWiseIncentive>>([]);
    const dt: any = useRef<any>(null);
    const modalHeader = "Generate Invoice";
    const hideDialog = () => {
        setTableData([]);
        props.setModal({ open: false, singleData: [] });
    };

    const onGenerateInvoice = async () => {
        const response = await Fetch("InvoiceTracking/invoiceGeneratedBranchWiseIncentiveCalculation", "PUT", props.modal.singleData, null, props.toast);
        if (response) {
            props.setReload(!props.reload);
            hideDialog();
        }
    };

    useEffect(() => {
        if (props.modal.open) {
            setTableData(props.modal.singleData);
        }
    }, [props.modal.open]);

    return (
        <>
            <Dialog visible={props.modal.open} style={{ width: '80vw' }} header={modalHeader} className="p-fluid" onHide={hideDialog} draggable={false}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData}
                    emptyMessage="No Branches found."
                >
                    <Column field="invoiceNO" header="Invoice NO" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                    <Column field="fromDate" header="From Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: IBranchWiseIncentive) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />
                    <Column field="toDate" header="To Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: IBranchWiseIncentive) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />
                    <Column field="consultant_Name" style={{ minWidth: '8rem', maxWidth: '8rem' }} header="Consultant Name" />
                    <Column field="vendor_Company_Name" style={{ minWidth: '9rem', maxWidth: '9rem' }} header="Vendor Company Name" />
                    <Column field="invoiceHours" header="Invoice Hours" />
                    <Column field="calculatedAmount" header="Calculated Amount" />
                    <Column field="sales_Company_Name" header="Sales Company Name" />
                    <Column field="salesBranchName" header="Sales Branch Name" />
                    <Column field="salesBranchPercentage" header="Sales Branch Percentage" />
                    <Column field="salesBranchAmount" header="Sales Branch Amount" body={(rowData) => <p>{Number(rowData.salesBranchAmount).toFixed()}</p>} />
                    <Column field="recruiter_Company_Name" header="Recruiter Company Name" />
                    <Column field="recruiter_Branch_Name" header="Recruiter Branch Name" />
                    <Column field="recruitersBranchPercentage" header="Recruiters Branch Percentage" />
                    <Column field="recruitersBranchAmount" header="Recruiters Branch Amount" body={(rowData) => <p>{Number(rowData.recruitersBranchAmount).toFixed()}</p>} />
                    <Column field="homeBranchAPercentage" header="Noida Home Branch Percentage" />
                    <Column field="homeBranchAAmount" header="Noida Home Branch Amount" body={(rowData) => <p>{Number(rowData.homeBranchAAmount).toFixed()}</p>} />
                    <Column field="homeBranchBPercentage" header="BBS Home Branch Percentage" />
                    <Column field="homeBranchBAmount" header="BBS Home Branch Amount" body={(rowData) => <p>{Number(rowData.homeBranchBAmount).toFixed()}</p>} />
                </DataTable>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button label="YES" type={"button"} style={{ width: '100px' }} onClick={onGenerateInvoice} ></Button>
                    <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="NO" onClick={hideDialog} type="button" ></Button>
                </div>
            </Dialog>
        </>
    );
}